import React from 'react'
import PropTypes from 'prop-types'

export default class BillNotes extends React.Component {

  static propTypes = {
    billEditor: PropTypes.object.isRequired
  }

  handleTextChanged = event => {
    event.preventDefault()
    this.props.billEditor.setNotes(this.input.value)
  }

  render() {
    return (
      <div style={styles.container}>
        <div style={styles.label}>Notes</div>
        <textarea
          style={{ ...styles.input, ...styles.textArea }}
          ref={input => this.input = input}
          rows={5}
          value={this.props.billEditor.getNotes()}
          placeholder='Enter notes'
          onChange={this.handleTextChanged}/>
      </div>
    )
  }

}

const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    marginBottom: 36
  },
  input: {
    borderRadius: 4,
    border: 'solid 1px #e6e8ed',
    color: '#4a4a4a',
    padding: '7px 11px 7px 11px',
    fontSize: 14
  },
  textArea: {
    resize: 'none'
  },
  label: {
    fontSize: 14,
    marginBottom: 18,
    color: '#494949'
  }
}



// WEBPACK FOOTER //
// ./src/billing/common/modules/notes/BillNotes.js